export enum MeasurementStatus {
  Active = 'active',
  Archived = 'archived',
}
